var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormFmSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pin_tic_fm_sb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.1,
    height: 44.136,
    viewBox: "0 0 57.1 44.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Common_Components_Map_Components_Pins_Assigned_Pin_Copy_2",
    "data-name": "Common Components/Map Components/Pins/Assigned Pin Copy 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    transform: "translate(16) rotate(90)",
    fill: "#006194"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke",
    transform: "translate(16) rotate(90)",
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.554248809814453 1 L 1.179248809814453 8 L 5.554248809814453 15 L 34.44575119018555 15 L 38.82075119018555 8 L 34.44575119018555 1 L 5.554248809814453 1 M 5 0 L 35 0 L 40 8 L 35 16 L 5 16 L 0 8 L 5 0 Z",
    stroke: "none",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Map_Components_Work_Pins_Assigned_Pin_Copy_43",
    "data-name": "Map Components / Work Pins / Assigned Pin Copy 43",
    transform: "translate(12 0.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14_Copy",
    "data-name": "Group 14 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    "data-name": "Fill",
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    transform: "translate(16 0) rotate(90)",
    fill: "#45b63f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke-2",
    "data-name": "Stroke",
    transform: "translate(16 0) rotate(90)",
    fill: "none",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.554248809814453 1 L 1.179248809814453 8 L 5.554248809814453 15 L 34.44575119018555 15 L 38.82075119018555 8 L 34.44575119018555 1 L 5.554248809814453 1 M 5 0 L 35 0 L 40 8 L 35 16 L 5 16 L 0 8 L 5 0 Z",
    stroke: "none",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Map_Components_Work_Pins_Assigned_Pin_Copy_42",
    "data-name": "Map Components / Work Pins / Assigned Pin Copy 42",
    transform: "translate(32 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Map_Components_Pins_Assigned_Pin_background",
    "data-name": "Map Components / Pins / Assigned Pin background",
    width: 20,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14_Copy-2",
    "data-name": "Group 14 Copy",
    transform: "translate(-8.4 -0.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M4,0l9,21L8,29,0,10Z",
    transform: "translate(29 26) rotate(90)",
    fill: "rgba(0,0,0,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    "data-name": "Fill",
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    transform: "translate(16 0) rotate(90)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke-3",
    "data-name": "Stroke",
    transform: "translate(16 0) rotate(90)",
    fill: "none",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.554248809814453 1 L 1.179248809814453 8 L 5.554248809814453 15 L 34.44575119018555 15 L 38.82075119018555 8 L 34.44575119018555 1 L 5.554248809814453 1 M 5 0 L 35 0 L 40 8 L 35 16 L 5 16 L 0 8 L 5 0 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormFmSb);
export default __webpack_public_path__ + "static/media/norm_fm_sb.549cd6377e248fbf4875dcc58497f188.svg";
export { ForwardRef as ReactComponent };